export default "__VITE_ASSET__9d95f39c__"